export default "__VITE_ASSET__9ACxYteg__"